import BarChart from "@mui/icons-material/BarChart";
import { Stack, Tooltip, Typography } from "@mui/material";
import type { GridRenderCellParams } from "@mui/x-data-grid-pro";
import type { FC } from "react";
import type { ChannelName } from "../../../../modules/channels/types";
import type { TransformedSentMomentData } from "../hooks/use-sent-moment-data";

export const HasPollsOrSurveysCell: FC<{
  params: GridRenderCellParams<TransformedSentMomentData, ChannelName>;
}> = ({ params }) => {
  if (!params.value) return null;

  const { poll_ids: pollIds, survey_data: surveyData } = params.row;

  return (
    <HasPollsOrSurveys
      pollCount={pollIds?.length || 0}
      surveyTitles={surveyData?.map((survey) => survey.title) || []}
    />
  );
};

export const HasPollsOrSurveys: FC<{
  pollCount: number;
  surveyTitles: string[];
}> = ({ pollCount, surveyTitles }) => {
  if (!pollCount && !surveyTitles.length) return null;
  return (
    <Tooltip title={<HasPollsOrSurveysToolTip pollCount={pollCount} surveyTitles={surveyTitles} />}>
      <Stack justifyContent="center" alignItems="center" height="100%">
        <BarChart fontSize="small" sx={{ color: "text.secondary" }} />
      </Stack>
    </Tooltip>
  );
};

const HasPollsOrSurveysToolTip: FC<{
  pollCount: number;
  surveyTitles: string[];
}> = ({ pollCount, surveyTitles }) => {
  return (
    <Stack justifyContent="center" alignItems="flex-start" direction="column" spacing={1}>
      {pollCount > 0 && (
        <Typography variant="body2">Communication contains {pollCount} poll(s)</Typography>
      )}
      {surveyTitles.length > 0 && (
        <Typography variant="body2">
          Communication contains links to the following survey(s):
        </Typography>
      )}
      {surveyTitles.map((survey, index) => (
        <Typography key={index} variant="caption">
          {survey}
        </Typography>
      ))}
    </Stack>
  );
};
